<template>
    <div class="footer">
        <div class="top-con">
            <div class="title">Social Media accounts of New Legend Education and Migration</div>
            <div class="top-lists">
                <div class="bg-img-con">
                    <img src="../../assets/imgs/fix-1.jpg" alt="">
                </div>
                <div class="list">
                    <div class="title">Contact Us</div>
                    <div class="img">
                        <img src="../../assets/imgs/Emma-150x150.jpg" alt="">
                        <p>Consultation and Appointment</p>
                    </div>
                    <div class="img">
                        <img src="../../assets/imgs/gzh.jpg" alt="">
                        <p>WeChat Official Account</p>
                    </div>
                    <div class="img">
                        <img src="../../assets/imgs/xhsewm.png" alt="">
                        <p>Xiaohongshu</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="blue">
            <div class="con">
                <div class="lists">
                    <div class="list" v-appear-animation="{ appearClass: 'animate-slide-in-left' }">
                        <div class="title">Australian Headquarters (Sydney)</div>
                        <p>
                            <img src="../../assets/imgs/dizhi.png" alt="">
                            Suite1 Level13 Tower1 475 Victoria Avenue , Chatswood NSW 2067
                        </p>
                        <p>
                            <img src="../../assets/imgs/youxiang.png" alt="">
                            contact@newlegend.com.au
                        </p>
                        <p>
                            <img src="../../assets/imgs/dianhua.png" alt="">
                            (+61) 2 8076 6493
                        </p>
                    </div>
                    <div class="list" v-appear-animation="{ appearClass: 'animate-slide-in-left' }">
                        <div class="title">Chinese Headquarters (Beijing)</div>
                        <p>
                            <img src="../../assets/imgs/dizhi.png" alt="">
                            北京市朝阳区东三环中路7号北京财富中心写字楼A座31层3105
                        </p>
                    </div>
                    <div class="list" v-appear-animation="{ appearClass: 'animate-slide-in-right' }">
                        <div class="title">Offices in Other Cities</div>
                        <p class="small-title">Shenzhen Office :</p>
                        <p>
                            <img src="../../assets/imgs/dizhi.png" alt="">
                            深圳市龙岗区龙城街道丰隆深港科技园产业促进中心三楼302
                        </p>
                        <p class="small-title">Hohhot Office :</p>
                        <p>
                            <img src="../../assets/imgs/dizhi.png" alt="">
                            呼和浩特市新城区兴安路兴安路8号院C1
                        </p>
                        <p class="small-title">Vietnam Office :</p>
                        <p>
                            <img src="../../assets/imgs/dizhi.png" alt="">
                            25/5 Van Cao, Phu Thanh ward, Tan Phu District, Ho Chi Minh City, Viet Nam, 700000
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="bottom">
            <span>COPYRIGHT © 2023 NEWLEGEND EDUCATION AND MIGRATION. ALL RIGHTS RESERVED.
            </span>
            <a href="https://www.mara.gov.au/tools-for-registered-agents/code-of-conduct" target="_blank">
                CODE OF CONDUCT
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Footer',
    data() {
        return {
            navList: []
        }
    },
    mounted() {
        this.getListFn()
    },
    methods: {
        toPageFn(item, index, childIndex) {
            if (item.nav_title == '首页') {
                this.$router.push('/en/index')
            } else if (item.nav_title == '联系我们') {
                this.$router.push('/en/contactUs')
            } else if (item.nav_title == '下签喜报') {
                this.$router.push('/en/goodNews')
            } else {
                if (childIndex) {
                    this.$router.push('/en/immigration?nav_id=' + item.nav_id + "&currentNav=" + childIndex)
                } else {
                    this.$router.push('/en/immigration?nav_id=' + item.nav_id)
                }
            }
            localStorage.setItem('nav_item', JSON.stringify(item))
        },
        getListFn() {
            this.$http.nav_bottom_list().then(res => {
                let list = res.data;
                // 去掉list里nav_title==联系我们
                list = list.filter(item => item.nav_title !== '联系我们')
                this.navList = list;

            })
        }
    }
}
</script>

<style lang="less" scoped>
// 深黑 333333
// 浅黑 c4cad6

.footer {
    background: #f1f1f18b;

    .top-con {
        padding-top: 30px;
        padding-bottom: 30px;

        .top-lists {
            display: flex;
            max-width: 1200px;
            margin: 0 auto;
        }

        .bg-img-con {
            flex: 1;
            min-height: 400px;
            margin-right: 40px;
            box-sizing: border-box;
            background-color: #fddee5;

            img {
                width: 100%;
                height: auto;
            }
        }

        .list {
            width: 130px;
            flex-shrink: 0;
        }

        .list {
            cursor: pointer;

            .img img {
                width: 90px;
                height: auto;
            }

            .img {
                text-align: center;
                width: 90px;
                margin-bottom: 15px;

                p {
                    line-height: 1;
                }
            }

            p {
                line-height: 1.8;
                color: #333333;
                text-shadow: 1px 1px 1px #ffffff84;
            }
        }

        .title {
            color: #333333;
            font-size: 30px;
            text-shadow: 1px 1px 1px #ffffff70;
            position: relative;
            padding-bottom: 15px;
            font-weight: 600;
            margin-bottom: 10px;
            text-align: center;
        }

        .list .title {
            font-weight: 400;
            font-size: 20px;
            text-align: left;
        }
    }

    .con {
        margin: 0 auto;
        max-width: 1200px;
    }

    .bottom {
        background-color: #333333;
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 14px;
        border-top: 1px solid #ffffff7d;

        a {
            color: #fff;
            margin-left: 40px;
            text-decoration: none;
        }
    }

    .blue {
        padding-top: 10px;
        background-color: #e6e6e7;
    }

    .lists {
        display: flex;
        margin-top: 30px;
        justify-content: space-between;

        .list {
            width: 30%;
            margin-right: 30px;
            padding-bottom: 40px;

            img {
                width: 24px;
                height: 24px;
                display: inline-block;
                margin-right: 4px;
                // 滤镜 黑色
                filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(0%) contrast(100%);
            }



            .title {
                border-bottom: 1px solid #ffffff3d;
                padding-bottom: 20px;
                color: #333333;
                font-size: 20px;
                font-weight: 600;
                margin-bottom: 35px;
            }

            p {
                color: #333;
                font-size: 14px;
                display: flex;
                margin-bottom: 20px;

                span {
                    display: inline-block;
                    margin-right: 10px;
                    margin-bottom: 10px;
                }
            }

            .small-title {
                margin-bottom: 3px;
                font-size: 16px;
                font-weight: 500;
                color: #333333;
            }

            .img {
                width: 200px;
                margin-bottom: 30px;
            }
        }
    }

    .info {
        p {
            color: #fff;
            line-height: 2.5;
            font-size: 17px;
        }
    }
}

@media (max-width: 899px) {

    .footer {
        .top-con {
            padding-top: 20px;
            padding-bottom: 20px;

            .title {
                font-size: 20px;
                padding-bottom: 10px;
            }

            .top-lists {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                padding: 0 20px;
                box-sizing: border-box;
            }

            .bg-img-con {
                width: 100%;
                margin-right: 0;
                margin-bottom: 20px;
            }

            .list {
                width: 100%;
                margin-bottom: 20px;
                text-align: center;

                .title {
                    font-size: 16px;
                    text-align: center;
                    margin-bottom: 15px;
                }

                .img {
                    display: inline-block;
                    margin-right: 20px;
                    margin-bottom: 15px;

                    &:last-child {
                        margin-right: 0;
                    }
                }

                p {
                    font-size: 12px;
                }
            }
        }

        .con {
            .lists {
                display: block;
                padding: 0 20px;
                box-sizing: border-box;

                .list {
                    width: 100%;
                    margin-right: 0;
                    padding-bottom: 30px;

                    .title {
                        font-size: 16px;
                        margin-bottom: 20px;
                        padding-bottom: 10px;
                    }

                    p {
                        margin-bottom: 10px;
                        font-size: 12px;
                        flex-wrap: wrap;
                    }

                    img {
                        width: 14px;
                        height: 14px;
                        margin-right: 8px;
                    }

                    .small-title {
                        font-size: 14px;
                        margin-top: 15px;
                        margin-bottom: 5px;
                    }
                }
            }
        }

        .bottom {
            height: auto;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 15px;
            box-sizing: border-box;
            font-size: 12px;
            text-align: center;

            a {
                margin-left: 0;
                margin-top: 10px;
            }
        }

    }
}

/* 响应式适配：小屏幕设备 */
@media (max-width: 480px) {
    .footer {
        .top-con {
            .list {
                .img {
                    width: 70px;

                    img {
                        width: 70px;
                    }

                    p {
                        font-size: 11px;
                    }
                }
            }
        }

        .con {
            .lists {
                .list {
                    p {
                        font-size: 11px;
                    }
                }
            }
        }

        .bottom {
            font-size: 11px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/en/footer.vue